import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CallServiceAbstract } from "../call.service";
import { SettingsService } from "../../settings.service";
import { AuthenticationService } from "../../auth/Authentication/authentication.service";
import { Subject } from 'rxjs';
import { NotificationService } from '../../notification.service';
import { StateService } from '../../state/state.service';
import { take } from "rxjs/operators";
import * as _ from "lodash";

@Injectable({
    providedIn: 'root'
})

export class GeneralProductsProducts extends CallServiceAbstract {
    constructor(
        http: HttpClient,
        settings: SettingsService,
        authentication: AuthenticationService,
        notify: NotificationService,
        state: StateService,
    ) {
        super(http, settings, authentication, notify, state, 'General_Products_Products', 'Продукти');
    }

    public predefineState(state) {
        state = super.predefineState(state);
        state.expand.push('MeasurementUnit($select=Code)');
        state.expand.push('ProductType($select=Name)');

        state.select = [
            'Id',
            'Name',
            'PartNumber',
            'ProductType',
            'StandardCostPerLot',
        ];

        state.top = 100000;
        return state;
    }

    public findProduct(partNumber) {
        let call = JSON.parse(JSON.stringify(this.stateTemplate));
        call.filter.filters.push({ field: 'PartNumber', operator: 'eq', value: "'" + partNumber + "'" });
        return this.filter(call)
    }

    public activeProducts() {
        let call = JSON.parse(JSON.stringify(this.stateTemplate));
        call.filter.filters.push({ field: 'Active', operator: 'eq', value: true });
        return this.filter(call)
    }

    public async filterByNameOrCode(str) {
        const byPartNumber = await this.productsByPartNumber(str).pipe(take(1)).toPromise();
        const byName = await this.productsByName(str).pipe(take(1)).toPromise();
        const productsByPartNumber = _.get(byPartNumber, 'value', []);
        const productsByName = _.get(byName, 'value', []);
        const products = _.uniqBy(productsByPartNumber.concat(productsByName), (p) => p.Id);
        return products;
    }

    public productsByPartNumber(partNumber) {
        let call = JSON.parse(JSON.stringify(this.stateTemplate));
        call.filter.filters.push({ field: 'Active', operator: 'eq', value: true });
        call.filter.filters.push({ field: 'PartNumber', operator: 'contains', value: partNumber });
        call.take = 10;
        return this.filter(call)
    }

    public productsByName(name) {
        let call = JSON.parse(JSON.stringify(this.stateTemplate));
        call.filter.filters.push({ field: 'Name', operator: 'contains', value: name });
        call.take = 10;
        return this.filter(call)
    }

    filter(filter) {
        let obz = new Subject();
        this.query(filter).subscribe(
            data => obz.next(data),
            err => obz.error(err)
        );
        return obz.asObservable();
    }
}